<template>
  <div class="customer__form modal modal--default">
    <div class="modal__panel modal__panel--termination">
      <div class="modal__logo-wrapper">
        <div class="modal__logo"></div>
      </div>

      <div class="modal__main-icon modal__main-icon--calls"></div>
      <div class="modal__back" @click="goBack()"></div>
      <div class="modal__close" @click="closeModal()"></div>

      <div class="form form--terminate">
        <div class="navigators">
          <div class="navigator navigator--active">
            <div class="navigator__bullet"></div>
            <div class="navigator__title">
              {{ $t(`addCallModal.title`) }}
            </div>
          </div>
        </div>
        <div class="add__form add__form--terminate">
          <transition name="fade" mode="out-in">
            <Loading v-if="formLoading" />
            <div v-else class="add__content">
              <div class="termination">
                <div class="termination__row">
                  <div class="termination__column">
                    <div class="form__field">
                      <VSelect v-if="customerMembers.length" class="select select--default" :options="customerMembers"
                        :reduce="(member) => member.id" :getOptionLabel="(member) => parseCustomerName(member)"
                        :placeholder="$t(`addCallModal.${'customer'}`)" v-model="customerId" />

                      <div v-else class="input input--default input--readonly">
                        {{ parseCustomerName(customerDetails) }}
                      </div>
                    </div>

                    <div class="form__field date-time-wrapper">
                      <div class="date-picker">
                        <label class="date-label label-block">{{ $t(`addCallModal.date`) }}</label>
                        <Datepicker class="input input--default date-picker" :class="{ 'select--error': dateHasError }"
                          :config="statics.datePickerConfig" :placeholder="$t(`addCallModal.date`)" v-model="date" />
                        <div class="form__error" v-if="dateHasError">
                          {{ $t(`addCallModal.dateErrorMsg`) }}
                        </div>
                      </div>
                      <div class="date-picker">
                        <label class="date-label label-block">{{ $t(`addCallModal.time`) }}</label>
                        <input type="time" class="input input--default input time-picker"
                          :class="{ 'select--error': timeHasError }" v-model="time" />
                        <div class="form__error" v-if="timeHasError">
                          {{ $t(`addCallModal.timeErrorMsg`) }}
                        </div>
                      </div>
                    </div>

                    <div class="form__field">
                      <VSelect class="select select--default" :class="{ 'select--error': categoryHasError }"
                        :options="categories" :reduce="(category) => category.id"
                        :getOptionLabel="(category) => `${category.name} `"
                        :placeholder="$t(`addCallModal.categoryDropdown`)" v-model="callCategoryId" />
                      <div class="form__error" v-if="categoryHasError">
                        {{ $t(`addCallModal.categoryErrorMsg`) }}
                      </div>
                    </div>
                  </div>

                  <div class="termination__column termination__column--middle">
                    <div class="form__field">
                      <VSelect class="select select--default" :class="{ 'select--error': agentHasError }"
                        :options="agents" :reduce="(agent) => agent.id"
                        :getOptionLabel="(agent) => `${agent.first_name} ${agent.last_name}`"
                        :placeholder="$t(`addCallModal.agentDropdown`)" v-model="agentId" />
                      <div class="form__error" v-if="agentHasError">
                        {{ $t(`addCallModal.agentErrorMsg`) }}
                      </div>
                    </div>

                    <div class="form__field form__field__call__duration">
                      <div class="call__duration__label">
                        <label class="date-label label-block">{{ $t(`addCallModal.callDuration`) }}</label>
                      </div>
                      <div class="call-duration" :class="{ 'select--error': durationHasError }">
                        <div class="call__duration__types">
                          <p class="call__duration__value"
                            :class="{ 'call__duration__value--active': durationMinutes == 15 }"
                            @click="selectCallDuration(15)">
                            15 min
                          </p>
                          <p class="call__duration__value"
                            :class="{ 'call__duration__value--active': durationMinutes == 30 }"
                            @click="selectCallDuration(30)">
                            30 min
                          </p>
                          <p class="call__duration__value"
                            :class="{ 'call__duration__value--active': durationMinutes == 45 }"
                            @click="selectCallDuration(45)">
                            45 min
                          </p>
                        </div>

                        <div class="custom-duration-wrapper">
                          <input type="number" v-model="hours" min="0" max="59" @input="validateHours"
                            class="custom-duration" placeholder="HH" />
                          <p><b>:</b></p>
                          <input type="number" v-model="minutes" min="0" max="59" @input="validateMinutes"
                            class="custom-duration" placeholder="mm" />
                        </div>

                      </div>

                      <div class="form__error" v-if="durationHasError">
                        {{ $t(`addCallModal.callDurationErrorMsg`) }}
                      </div>
                    </div>
                  </div>

                  <div class="termination__column">
                    <DropFile v-model="files" />
                  </div>
                </div>

                <div class="termination__row termination__textarea__row">
                  <div class="form__field form__notes__textarea">
                    <textarea :placeholder="$t(`addCallModal.text`)" cols="30" rows="10"
                      class="input input--default termination__textarea" v-model="description"
                      style="max-width: initial !important;"></textarea>
                  </div>
                </div>
              </div>
              <div v-if="isRequesting"
                class="modal__button modal__button--submit button button--default button--loading"></div>
              <div v-else-if="canSubmitCall" class="buttons-wrapper">
                <button v-if="!isCallEditing" type="button"
                  class="modal__button modal__button--submit modal__button--pend button button--default"
                  @click="continueToPendency = true; addCall();">
                  <span>{{ $t(`addPolicyModal.${"saveButtonOpenPendency"}`) }}</span>
                </button>
                <button v-if="!isCallEditing" class="modal__button modal__button--submit button button--default"
                  @click="addCall()">
                  <span>{{ $t(`addCallModal.saveBtn`) }}</span>
                </button>

                <button v-else class="modal__button modal__button--submit button button--default" @click="editCall()">
                  <span>{{ $t(`addCallModal.editBtn`) }}</span>
                </button>
              </div>
            </div>
          </transition>
        </div>
      </div>


    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted, } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import DropFile from "@/components/DropFile";
import Loading from "@/partials/Loading";
import { parseCustomerName } from "@/helpers/entityParsers";
import statics from "@/statics";
import { useI18n } from 'vue-i18n';

// eslint-disable-next-line no-unused-vars
const { t } = useI18n();


// Configuration Context
const store = useStore();
const route = useRoute();

// Reactive States
const formLoading = ref(true);
const isRequesting = ref(false);

const callDuration = ref(null);
const hours = ref("");
const minutes = ref("");
const seconds = ref(""); // Maintained internal reference from legacy calculation rules

const agentId = ref("");
const customerId = ref("");
const callCategoryId = ref("");
const date = ref("");
const time = ref("00:00");
const description = ref("");
const durationMinutes = ref("");
const files = ref([]);
const teamId = ref(null);

const agentHasError = ref(false);
const dateHasError = ref(false);
const timeHasError = ref(false);
const categoryHasError = ref(false);
const durationHasError = ref(false);
const durationMinutesCustom = ref("");

// Vuex Computed Mappings
const customerDetails = computed(() => store.getters.customerDetails);
const callsForms = computed(() => store.getters.callsForms);
const isCallEditing = computed(() => store.getters.isCallEditing);
const editingCallData = computed(() => store.getters.editingCallData);
const customerMembers = computed(() => store.getters.customerMembers);
const isSuperAdmin = computed(() => store.getters.isSuperAdmin);
const canSubmitCall = computed(() => {
  if (isSuperAdmin.value) return true;

  const teamId = Number(
    customerDetails.value?.team_id ?? customerDetails.value?.team?.id ?? customerMembers.value?.[0]?.team_id ?? 0
  );

  if (!teamId) return false;

  const permission = isCallEditing.value ? "call_edit" : "call_create";
  return store.getters.hasTeamPermission(permission, teamId);
});

const agents = computed(() => callsForms.value?.agents || []);
const categories = computed(() => callsForms.value?.categories || []);

const continueToPendency = ref(false);

// Input Validation Rules
const validateMinutes = () => {
  if (durationMinutes.value) {
    durationMinutes.value = "";
  }
  if (minutes.value > 59) {
    minutes.value = 59;
  } else if (minutes.value < 0 || isNaN(minutes.value)) {
    minutes.value = "";
  }
};

const validateHours = () => {
  if (callDuration.value) {
    callDuration.value = "";
  }
  if (hours.value < 0 || isNaN(hours.value)) {
    hours.value = "";
  }
};

const updateCallDuration = () => {
  let timeString = 0;
  if (Number(hours.value) && Number(hours.value) > 0) {
    timeString = Number(hours.value) * 60;
  }
  if (minutes.value && Number(minutes.value) > 0) {
    timeString += Number(minutes.value);
  }
  durationMinutesCustom.value = timeString;
  // When user enters custom duration, clear the preset selection
  if (timeString > 0) {
    durationMinutes.value = "";
  }
};

const selectCallDuration = (durationValue) => {
  seconds.value = "";
  minutes.value = "";
  hours.value = "";
  durationMinutesCustom.value = "";
  durationMinutes.value = durationValue;
};

// Internal Actions
const closeModal = () => {
  store.commit("setShowAddCallsModal", false);
  store.commit("setIsCallEditing", false);
  store.commit("setEditingCallData", null);
};

const goBack = () => {
  closeModal();
  store.commit("setShowAddActivityModal", true);
};

const validateFields = (callback) => {
  agentHasError.value = !agentId.value;
  dateHasError.value = !date.value;
  categoryHasError.value = !callCategoryId.value;
  durationHasError.value = !(durationMinutes.value || durationMinutesCustom.value);
  timeHasError.value = !time.value || time.value === "00:00";

  const isValid =
    !agentHasError.value &&
    !dateHasError.value &&
    !timeHasError.value &&
    !categoryHasError.value &&
    !durationHasError.value;

  callback(isValid);
};

const formatTimeBeforeSend = (timeValue) => {
  let [h, m] = timeValue.split(':');
  return `${h}:${m}`;
};

// Component Event Watchers
watch([minutes, hours], () => {
  updateCallDuration();
});

watch(agentId, (value) => {
  agentHasError.value = !value;
});

watch(date, (value) => {
  dateHasError.value = !value;
});

watch(time, (value) => {
  timeHasError.value = !value || value === "00:00";
});

watch(durationMinutesCustom, (value) => {
  // Only mark error if both custom and preset are empty
  if (durationMinutes.value || value) {
    durationHasError.value = false;
  }
});

watch(durationMinutes, (value) => {
  // Only mark error if both custom and preset are empty
  if (value || durationMinutesCustom.value) {
    durationHasError.value = false;
  }
});

watch(callCategoryId, (value) => {
  categoryHasError.value = !value;
});

// Initialization Lifecycle Context
onMounted(async () => {
  formLoading.value = true;

  // Reset error states on initialization
  agentHasError.value = false;
  dateHasError.value = false;
  timeHasError.value = false;
  categoryHasError.value = false;
  durationHasError.value = false;

  customerId.value = customerDetails.value.id;

  if (customerDetails.value.team) {
    teamId.value = Number(customerDetails.value.team.id);
    await store.dispatch("getCallsForms", teamId.value);
  }

  if (isCallEditing.value && editingCallData.value) {
    agentId.value = editingCallData.value.agent?.id || "";
    callCategoryId.value = editingCallData.value.category?.id || "";
    date.value = editingCallData.value.date || "";
    time.value = editingCallData.value.time || "00:00";
    description.value = editingCallData.value.description || "";
    durationMinutes.value = editingCallData.value.duration_minutes || "";

    // Properly initialize duration - if preset, don't set custom minutes
    if ([15, 30, 45].includes(Number(durationMinutes.value))) {
      minutes.value = "";
      hours.value = "";
      durationMinutesCustom.value = "";
    } else {
      // For custom durations, convert back to hours and minutes
      const totalMinutes = Number(durationMinutes.value) || 0;
      hours.value = Math.floor(totalMinutes / 60);
      minutes.value = totalMinutes % 60;
      durationMinutesCustom.value = totalMinutes;
      durationMinutes.value = ""; // Clear preset value if custom
    }
  }

  formLoading.value = false;
});

const openAddNewPendency = (call) => {
  if (!call) {
    return;
  }

  const agentId = call.agent?.id || call.agent_id;
  if (!agentId && !call.id) {
    return;
  }

  closeModal();
  store.commit("setShowAddPendencyModal", true);
  if (agentId) {
    store.commit("setFromPolicyAgentId", agentId);
  }
};

// Submission Actions Context
const addCall = async () => {
  if (!canSubmitCall.value) return;

  isRequesting.value = true;
  validateFields(async (isValid) => {
    if (isValid) {
      try {
        let duration = Number(durationMinutesCustom.value) > 0
          ? durationMinutesCustom.value
          : durationMinutes.value;

        const callId = await store.dispatch('createCalls', {
          agent_id: agentId.value,
          customer_id: customerId.value,
          call_category_id: callCategoryId.value,
          date: date.value,
          time: formatTimeBeforeSend(time.value),
          description: description.value,
          duration_minutes: duration
        });

        closeModal();

        if (files.value.length > 0) {
          const mappedFiles = files.value.map((file) => file.file);
          await store.dispatch("addCallsFile", {
            callId,
            files: mappedFiles,
          });

          await store.dispatch("getCalls", route.params.id);
        }

        if (continueToPendency.value) {
          const call = {
            agent: { id: agentId.value },
            id: callId
          };
          openAddNewPendency(call);
        }
      } catch (error) {
        // Error already handled by store action
      } finally {
        isRequesting.value = false;
      }
    } else {
      store.commit("setToast", {
        display: true,
        type: "error",
        message: t("messages.validationFailed"),
      });
      isRequesting.value = false;
    }
  });
};

const editCall = async () => {
  if (!canSubmitCall.value) return;

  isRequesting.value = true;
  validateFields(async (isValid) => {
    if (isValid) {
      let duration = durationMinutesCustom.value > 0
        ? durationMinutesCustom.value
        : durationMinutes.value;

      try {
        await store.dispatch('updateCalls', {
          id: editingCallData.value.id,
          agent_id: agentId.value,
          customer_id: customerId.value,
          call_category_id: callCategoryId.value,
          date: date.value,
          time: formatTimeBeforeSend(time.value),
          description: description.value,
          duration_minutes: duration
        });

        closeModal();
      } catch (error) {
        // Error already handled by store action
      } finally {
        isRequesting.value = false;
      }
    } else {
      store.commit("setToast", {
        display: true,
        type: "error",
        message: t("messages.validationFailed"),
      });
      isRequesting.value = false;
    }
  });
};
</script>

<style scoped lang="scss">
@use "../assets/scss/termination-potential-policy";

.modal__panel--termination {
  width: 1100px;
}

.add__form--terminate {
  width: 95% !important;
}

.call-duration {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 10px;
}

.select--error {
  border: 1px solid var(--border-9) !important;

}

.custom-duration-wrapper {
  background-color: var(--bg-3);
  color: var(--text-3);
  font-size: var(--x-small);
  border-radius: var(--radius-1);
  font-family: var(--muli-text-semi-bold);
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  gap: 0;
  height: 40px;
  width: 80px;
}

.custom-duration {
  background-color: transparent;
  height: 40px;
  color: var(--text-3);
  font-size: var(--x-small);
  text-align: center;
  font-family: var(--muli-text-semi-bold);
  border: none;
  width: 35px;
  padding: 0;
  margin: 0;
}

.custom-duration:focus {
  outline: none;
}

.custom-duration::placeholder {
  color: var(--text-8);
}

.custom-duration-wrapper p {
  margin: 0;
  padding: 0 4px;
  color: var(--text-3);
}


.time-picker {
  width: 100%;
  padding: 0.3em 0.5em;
  font-size: 1em;
  height: 40px;
  background-color: var(--bg-3);
  border: 1px solid transparent;
  border-radius: var(--radius-1);
  text-align: center;
  color: var(--text-2);
  font-family: var(--muli-text-semi-bold);
  box-sizing: border-box;
}

.time-picker:focus {
  outline: none;
  border: 1px solid var(--primary-color);
}

.time-picker::placeholder {
  color: var(--text-8);
}

.termination__row {
  border: 0;
  display: flex;
  gap: 16px;
}

.termination__column {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.form__field__call__duration {
  margin-top: 0;
}

.call__duration__label {
  margin-bottom: 8px;
}

.call__duration__label label {
  display: block;
  margin-bottom: 8px;
}

[data-theme="dark"] .call__duration__label p {
  color: white;
}

.call__duration__label p {
  color: #7F8FA480;
  font-size: 14px;
  margin: 0;
}

.call__duration__types {
  display: flex;
  gap: 3px;
  flex-wrap: wrap;
}

.call__duration__value {
  color: #B9C2CD;
  font-size: 16px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s ease;
  margin: 0;
}

.call__duration__value:hover {
  background-color: rgba(34, 219, 142, 0.1);
}

.call__duration__value--active {
  color: #22DB8E;
  background-color: rgba(34, 219, 142, 0.15);
  font-weight: bold;
}

.termination__textarea__row {
  margin-top: 12px;
}

.form__notes__textarea {
  width: 96%;
}


.date-picker {
  width: 48%;
  position: relative;
  z-index: 1;
}

.date-picker:nth-child(2) {
  width: 48%;
}

.date-time-wrapper {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.date-picker label {
  display: block;
  margin-bottom: 8px;
}

/* Remove unused styles */

.date-label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: var(--text-3);
}

.label-block {
  font-weight: 500;
  text-transform: capitalize;
}

.modal__button--pend {
  margin-right: 250px;
  width: 220px;
}

@media screen and (max-width: 500px) {
  .add__content {
    max-height: 66vh;
  }

  .termination__row {
    flex-direction: column;
    gap: 0;
    margin-bottom: 25px;
  }

  .termination__textarea__row {
    margin: 0
  }

  .custom-duration-wrapper {
    width: 120px;
  }

  .custom-duration {
    width: 52px;
  }

  .modal__button--pend { 
    width: 180px;
  }

  .button {
    margin: 0;
  }

  .buttons-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
  }
}
</style>
